import script from "./DocumentsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentsForm.vue?vue&type=script&setup=true&lang=js"

import "./DocumentsForm.vue?vue&type=style&index=0&id=5a197e18&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a197e18"]])

export default __exports__